export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="card text-center">
        <h1 className="text-2xl font-semibold text-primary">NotFoundPage</h1>
        <p className="text-gray-500 mt-2">À implémenter</p>
      </div>
    </div>
  )
}
